let burgerMenu = document.getElementById("burgerMenu");
let navigationList = document.querySelector(".navigation");

let navigationItems = document.querySelectorAll(".navigation .navigation__item");

burgerMenu.addEventListener("click", () => {
  navigationList.classList.toggle("navigation--open");
  burgerMenu.classList.toggle("is-active");
});

/**
 * Sub menu dropdowns
 */
navigationItems.forEach((item) => {
  const btns = item.querySelectorAll(".sub-navigation__arrow, .sub-navigation__button");
  if (btns && btns.length) {
    btns.forEach((btn) => {
      btn.addEventListener("click", onClick.bind(item));
    });
    item.addEventListener("mouseenter", mouseIn.bind(item));
    item.addEventListener("mouseleave", mouseLeave.bind(item));
  }
});

/**
 * Open and close sub menu by adding/removing "open"-class
 * @param {*} e - Event
 */
function onClick(e) {
  const item = this;

  if (item.classList.contains("open")) {
    item.classList.remove('open');
    const btns = item.querySelectorAll(".sub-navigation__arrow, .sub-navigation__button");
    btns.forEach((btn) => {
      btn.setAttribute("aria-expanded", "false");
    });

    item.setAttribute("aria-expanded", "false");
  } else {
    item.classList.add('open');
    const btns = item.querySelectorAll(".sub-navigation__arrow, .sub-navigation__button");
    btns.forEach((btn) => {
      btn.setAttribute("aria-expanded", "true");
    });
    item.setAttribute("aria-expanded", "true");
  }
}

/**
 * Whenever a user hovers over a menu item, open the sub menu.
 * Only on desktop (larger than 1000px)! Use button on mobile.
 * @param {*} e - Event
 * @returns 
 */
function mouseIn(e) {
  const match = window.matchMedia("(min-width: 1000px)");
  if (!match.matches) return; // Only run on desktop (larger than 1000px)

  const item = this;

  if (!item.classList.contains("open")) {
    item.classList.add('open');
    const btns = item.querySelectorAll(".sub-navigation__arrow, .sub-navigation__button");
    btns.forEach((btn) => {
      btn.setAttribute("aria-expanded", "true");
    });
    item.setAttribute("aria-expanded", "true");
  }
}

/**
 * Whenever a user mouse leaves a menu item/submenu, hide the sub menu.
 * Only on desktop (larger than 1000px)! Use button on mobile.
 * @param {*} e - Event
 * @returns 
 */
function mouseLeave(e) {
  const match = window.matchMedia("(min-width: 1000px)");
  if (!match.matches) return; // Only run on desktop (larger than 1000px)

  const item = this;

  if (item.classList.contains("open")) {
    item.classList.remove('open');
    const btns = item.querySelectorAll(".sub-navigation__arrow, .sub-navigation__button");
    btns.forEach((btn) => {
      btn.setAttribute("aria-expanded", "false");
    });
    item.setAttribute("aria-expanded", "false");
  }
}